import { useState } from "react";
import styled from "styled-components";

const InputBoxDisableTrans = ({
  initialValue,
  message,
  type,
  width,
  handleInput,
  hasError,
  setError_message,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [hasNoValue, setHasNoValue] = useState(false);
  const [tempValue, setTempValue] = useState(initialValue ? initialValue : "");
  const [value_count, setValue_count] = useState(0);

  const handleBlur = (e) => {
    if (e.target.value === "") {
      if (type === "email") {
        setError_message("기업 이메일을 입력해주세요");
      } else if (type === "certNumber") {
        setError_message("인증번호를 입력해주세요");
      } else if (type === "password") {
        setError_message("비밀번호를 입력해주세요");
      }
      setHasNoValue(true);
    } else if (type === "email" && !e.target.value.includes("@")) {
      setError_message("이메일 형식에 맞게 작성해주세요");
      setHasNoValue(true);
    } else {
      if (type === "companyName") {
        setHasNoValue(false);
      } else {
        if (hasError) {
          setHasNoValue(true);
        } else {
          setHasNoValue(false);
          setError_message("");
        }
      }
    }
    setIsClicked(false);
  };

  const handleValueCount = (value) => {
    if (type === "companyName") {
      if (value.length <= 7) {
        setTempValue(value);
        setValue_count(value.length);
      }
    } else setTempValue(value);
  };
  return (
    <InputContainer
      width={width}
      $hasError={hasError}
      $hasNoValue={hasNoValue}
      $isClicked={isClicked}
      type={type}
    >
      <input
        type={type}
        placeholder={message}
        onChange={(e) => {
          handleInput(e.target.value);
          handleValueCount(e.target.value);
        }}
        onClick={() => setIsClicked(true)}
        onBlur={handleBlur}
        value={tempValue}
      />
      {type === "companyName" && (
        <p style={{ color: "#b0b0b0" }}>{value_count}/7</p>
      )}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  width: 384px;
  width: ${(props) => props.width};
  height: 55px;
  border-radius: 10px;
  box-shadow: ${(props) =>
    props.$isClicked
      ? "inset 0 0 0 1px #1167ed"
      : props.$hasError ||
        (props.$hasNoValue &&
          (props.type === "companyName" ||
            props.type === "password" ||
            props.type === "email" ||
            props.type === "certNumber"))
      ? "inset 0 0 0 1px #f25c5c"
      : "inset 0 0 0 1px #e4e4e4"};
  display: flex;
  align-items: center;
  background-color: #ffffff;
  cursor: pointer;
  padding-right: 16px;
  > input {
    width: 472px;
    height: 23px;
    font-family: "notoSans";
    font-size: 16px;
    margin-left: 14px;
    border: none;
    z-index: 1;
    &:focus {
      outline: none;
    }
  }
`;

export default InputBoxDisableTrans;
